import React, { useEffect, useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import { useLang } from '@/i18n';
import EcoTabSwiper, { EcoTabSwiperItemProps } from 'eco-design/sections/eco-tab-swiper';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import style from './index.module.scss';
import { useRouter } from 'next/router';

interface Props {}

const TabSwiper: React.FC<Props> = ({}) => {
    const { t } = useLang('powerBank.J');
    const { locale = 'us' } = useRouter();
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const IS_US = ['ca', 'us'].includes(locale);

    let items: EcoTabSwiperItemProps[] = [
        {
            bottomContent: t('J_tab1_desc'),
            tabLabel: t('J_tab1'),
            tabValue: '1',
            pc:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1762507410906/pc_Style%20Meets%20Function_%20(1).jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1750046464719/pc_Style%20Meets%20Function_.jpg',
            pad:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1762507410930/pc_Style%20Meets%20Function_.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1750046259153/pc_Style%20Meets%20Function_.jpg',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('J_tab1'), list_name: t('J_title') || 'none' },
        },
        {
            bottomContent: t('J_tab2_desc'),
            tabLabel: t('J_tab2'),
            tabValue: '2',
            pc:
                IS_EU || IS_US
                    ? 'https://websiteoss.ecoflow.com/upload/image/1750322695474/pc_Pocket-sized%20Power_%20(1).jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1750045989931/pc_Pocket-sized%20Power_%20(2).jpg',
            pad:
                IS_EU || IS_US
                    ? 'https://websiteoss.ecoflow.com/upload/image/1750322695474/pc_Pocket-sized%20Power_%20(1).jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1750045990350/pc_Pocket-sized%20Power_%20(3).jpg',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('J_tab2'), list_name: t('J_title') || 'none' },
        },
        {
            bottomContent: t('J_tab3_desc'),
            tabLabel: t('J_tab3'),
            tabValue: '3',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750046464175/pc_Built-in%20AC%20Plug_.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1750046311330/pc_Built-in%20AC%20Plug_.jpg',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('J_tab3'), list_name: t('J_title') || 'none' },
        },
        {
            bottomContent: t('J_tab4_desc'),
            tabLabel: t('J_tab4'),
            tabValue: '4',
            pc:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1762507422644/pc_Built-in%2C%20Retractable%20Cables_%20(1).jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1753260110983/pc_Built-in%2C%20Retractable%20Cables_.jpg',
            pad:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1762507422844/pc_Built-in%2C%20Retractable%20Cables_.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1753260222300/pc_Built-in%2C%20Retractable%20Cables_.jpg',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('J_tab4'), list_name: t('J_title') || 'none' },
        },
    ];
    if (IS_EU) {
        items.splice(2, 1);
    }
    if (locale === 'ph') {
        items = [items[0], items[2], items[3]];
    }
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secneTab = AniContainer.create({
                triggerElement: '.Rapid-I',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secneTab.destroy();
            };
        }
    }, []);
    return (
        <div className={`GtmModuleData-section`} data-section-id="Rapid-TabSwiper">
            <EcoSpace />
            <EcoTitle title={t('J_title')} />
            <EcoSpaceSmall />
            <div>{<EcoTabSwiper className={style.comp} items={items} />}</div>
        </div>
    );
};
export default TabSwiper;
